import { ref } from '@vue/composition-api'
import boyStatusApi from '@/services/api/boyStatus'

export default function useBoyStatusHistory(entityType) {
  const history = ref([])
  const loading = ref(false)
  const statusOptions = ref([])
  const ownerOptions = ref([])
  const ownerLoading = ref(false)
  const saving = ref(false)

  async function fetch(entityId) {
    loading.value = true
    try {
      const fetcher = entityType === 'horse' ? boyStatusApi.horseHistory : boyStatusApi.riderHistory
      const { data } = await fetcher(entityId)
      history.value = data.data
    } finally {
      loading.value = false
    }
  }

  async function fetchStatusOptions() {
    const fetcher = entityType === 'horse' ? boyStatusApi.horseStatuses : boyStatusApi.riderStatuses
    const { data } = await fetcher()
    statusOptions.value = data.data
  }

  // Owner is horse-only — riders have no owner concept, so there's nothing to search for them.
  // Searches Members/Member Secretaries by name (server-side), triggered on dropdown open/typing.
  async function searchOwnerOptions(entityId, search) {
    if (entityType !== 'horse') return
    ownerLoading.value = true
    try {
      const { data } = await boyStatusApi.horseOwnerOptions(entityId, search)
      ownerOptions.value = data.data
    } finally {
      ownerLoading.value = false
    }
  }

  // Pre-seeds the dropdown with the currently-assigned owner so it displays correctly
  // the moment the Backdate modal opens, before any search has run.
  function seedOwnerOptions(owner) {
    ownerOptions.value = owner ? [owner] : []
  }

  async function save(entityId, stateId, payload) {
    saving.value = true
    try {
      let response
      if (stateId) {
        response = entityType === 'horse'
          ? await boyStatusApi.updateHorse(entityId, stateId, payload)
          : await boyStatusApi.updateRider(entityId, stateId, payload)
      } else {
        response = entityType === 'horse'
          ? await boyStatusApi.createHorse(entityId, payload)
          : await boyStatusApi.createRider(entityId, payload)
      }
      return response.data.message
    } finally {
      saving.value = false
    }
  }

  async function clearRecalculationFlag(entityId, stateId) {
    saving.value = true
    try {
      const response = entityType === 'horse'
        ? await boyStatusApi.clearHorseRecalculationFlag(entityId, stateId)
        : await boyStatusApi.clearRiderRecalculationFlag(entityId, stateId)
      return response.data.message
    } finally {
      saving.value = false
    }
  }

  async function remove(entityId, stateId) {
    saving.value = true
    try {
      const response = entityType === 'horse'
        ? await boyStatusApi.deleteHorseState(entityId, stateId)
        : await boyStatusApi.deleteRiderState(entityId, stateId)
      return response.data.message
    } finally {
      saving.value = false
    }
  }

  return {
    history, loading, statusOptions, ownerOptions, ownerLoading, saving, fetch, fetchStatusOptions, searchOwnerOptions, seedOwnerOptions, save, clearRecalculationFlag, remove
  }
}



// WEBPACK FOOTER //
// ./src/composables/useBoyStatusHistory.js